import * as React from 'react';

import type * as api from '@gitbook/api-client';
import { Radio } from '@gitbook/react-uikit';

import { useContentKitConfirm } from './ContentKitConfirm';
import type { ContentKitElementProps, ContentKitElementRef } from './types';

/**
 * Renderer for a radio element.
 */
export function ContentKitRadio({
    ref,
    ...props
}: ContentKitElementProps<api.ContentKitRadio> & {
    ref?: React.Ref<ContentKitElementRef>;
}): React.ReactElement {
    const { element, localState, setLocalState } = props;

    const value = localState[element.state] === element.value;

    const [confirm, wrapConfirm] = useContentKitConfirm();

    const press = () => {
        if (element.disabled) {
            return;
        }

        // Only show confirm when the radio is not checked
        wrapConfirm(value ? undefined : element.confirm, () => {
            setLocalState((prev) => {
                return {
                    ...prev,
                    [element.state]: element.value,
                };
            });
        });
    };

    React.useImperativeHandle(ref, () => ({
        press,
    }));

    return (
        <>
            <Radio value={value} disabled={element.disabled} onValueChange={press} />
            {confirm}
        </>
    );
}
